import {
  type DemoOverlay,
  type IDemo,
  RecordingTypes,
} from '@carboncopyco/types';
import type { SpeakerPanelData } from '@carboncopyco/types/desktop';
import {
  SettingMainItemsKeys,
  SettingsSubKeys,
} from '@carboncopyco/types/desktop/appSettings';

export const createDemoPreviewSpeakerPanelData = async (
  demo: IDemo | DemoOverlay,
  groupId: number,
  notes = ''
) => {
  const appSettings = await window?.dsDesktop?.appSettings?.getAppSettings();
  const appSettingsIsMouseHighlightActive =
    appSettings?.[SettingMainItemsKeys.MouseAnimation][
      SettingsSubKeys.MouseAnimationToggleState
    ];

  const appSettingsIsOpenByDefault =
    appSettings?.[SettingMainItemsKeys.PresentationDisplay][
      SettingsSubKeys.ShowSpeakerPanelByDefault
    ];

  const initialSpeakerPanelData: SpeakerPanelData = {
    currentTime: 0,
    isNotesOpen: false,
    isWindowOpen: false,
    isOpen: appSettingsIsOpenByDefault ?? false,
    activePresentationIndex: 0,
    demosInfo: [
      {
        presentationName: demo.demoName,
        image: demo.image,
        notes,
        id: demo.id,
        screenshotImageType:
          demo.recordingType === RecordingTypes.overlay ? 'overlay' : 'demo',
        canDetach: true,
      },
    ],
    isMouseHighlightActive: appSettingsIsMouseHighlightActive ?? false,
  };

  await window?.dsDesktop?.speakerPanel.setData(
    groupId,
    initialSpeakerPanelData
  );
};
